module.exports = __webpack_public_path__ + "img/高压电池1.d488a5d2.png";